export default __webpack_public_path__ + "static/media/maintenance-icon.07089177.svg";